import { isEmpty } from "lodash";
import { ReportableBase } from "../services/reports/base/ReportableBase";

export default function useReport<TReportableData>(
  reportable: ReportableBase<TReportableData>
) {
  function handleReport(callAfter: number) {
    setTimeout(() => {
      const reportableData = reportable.getReportableData();

      if (!isEmpty(reportableData)) {
        reportable.report(reportableData);
      }
    }, callAfter);
  }

  return {
    handleReport,
  };
}
